import { cacheTypes, deleteMethod, getMethod, postMethod, putMethod } from "../../../store/api/CommonFunctions";

const BASE_URL = "api/WorkItemCheckListAPI";
/**
 * 
 * @typedef {object} WorkItemChecklist
 * @property {number} DoneByID
 * @property {string} DoneByName
 * @property {Date} DoneDate
 * @property {number} ID
 * @property {boolean} IsDone
 * @property {number} SortOrder
 * @property {string} Title
 * @returns 
 */
/**
 * 
 * @param {[WorkItemChecklist]} data 
 * @returns {{Data:[WorkItemChecklist]}}
 */
export const createList = async (data) => {
    const result = await postMethod(`${BASE_URL}/CreateList`, data, "CreateList");
    return result;
}
/**
 * 
 * @param {[WorkItemChecklist]} data 
 * @returns {{Data:[WorkItemChecklist]}}
 */
export const updateList = async (data)=>{
    const result = await putMethod(`${BASE_URL}/UpdateList`, data, "UpdateList");
    return result;
}
/**
 * 
 * @param {number} id 
 * @returns {{Data:boolean}}
 */
export const deleteFromList = async (id)=>{
    const result = await deleteMethod(`${BASE_URL}/DeleteFromList?id=${id}`,"DeleteFromList");
    return result;
}
/**
 * 
 * @param {number} id 
 * @returns {{Data:boolean}}
 */
export const changeDoneStatus = async (id)=>{
    const result = await getMethod(`${BASE_URL}/ChangeDoneStatus?id=${id}`, cacheTypes.NoCache, "ChangeDoneStatus");
    return result;
}
/**
 * 
 * @param {WorkItemChecklist} data 
 * @returns {{Data:boolean}}
 */
export const setDoneComment = async (data)=>{
    const result = await putMethod(`${BASE_URL}/setDoneComment`, data, "SetDoneComment");
    return result;
}